import { FC, useMemo } from 'react';
import { hasFlag } from '@netiva/classifieds-common';
import { Alert, AlertData } from '@netiva/classifieds-ui';

import { useAppSelector } from '@/store';
import { useTranslation } from 'react-i18next';

export const AccountStatus: FC = () => {
  const { t } = useTranslation();
  const { account } = useAppSelector((state) => state.account);

  const alert = useMemo<AlertData | null>(() => {
    const lockedClassifieds = hasFlag(account?.accountStatus, 'LockedClassifieds');
    const lockedPrint = hasFlag(account?.accountStatus, 'LockedPrint');
    const lockedSuspiciousActivity = hasFlag(account?.accountStatus, 'LockedSuspiciousActivity');

    if (lockedClassifieds || lockedPrint || lockedSuspiciousActivity) {
      return {
        status: 'warning',
        title: t('account.lockedAlert.title'),
        description: (() => {
          if (lockedClassifieds && lockedPrint) {
            return t('account.lockedClassifiedsAndPrint.description');
          } else if (lockedClassifieds) {
            return t('account.lockedClassifieds.description');
          } else if (lockedPrint) {
            return t('account.lockedPrint.description');
          } else if (lockedSuspiciousActivity) {
            return t('account.lockedSuspiciousActivity.description');
          } else {
            return t('account.lockedAlert.description');
          }
        })(),
      };
    }
    return null;
  }, [account?.accountStatus, t]);

  if (!alert) {
    return null;
  }

  return <Alert alert={alert} />;
};
